import { BrandVariant } from '@/types/internal-contracts/auth';
import { getShellBaseUrl } from '@/services/core';

// public/index.html ships this link with an empty data: URL until the boot sets
// it, so the browser never falls back to the origin's /favicon.ico.
const FAVICON_ID = 'app-favicon';

// nginx sends no Cache-Control for these files, so a browser keeps a cached icon.
// Bump the version when a brand's favicon changes, so the new one shows at once.
const AUTOMILE_FAVICON_PATH = 'branding/automile/favicon.png?v=2';

function faviconHrefFor(brand: BrandVariant): string {
  const path = brand === 'automile' ? AUTOMILE_FAVICON_PATH : 'favicon.png';
  return new URL(path, getShellBaseUrl()).toString();
}

/** Points the tab icon at the brand's favicon. */
export function applyBrandFavicon(brand: BrandVariant): void {
  let link = document.getElementById(FAVICON_ID) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = FAVICON_ID;
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = faviconHrefFor(brand);
}
